import { render, staticRenderFns } from "./More.vue?vue&type=template&id=2012872a&scoped=true&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "./More.vue?vue&type=style&index=0&id=2012872a&scoped=true&lang=css&"
import style1 from "./More.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012872a",
  null
  
)

export default component.exports